import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.load()
  }

  async load() {
    const response = await fetch(this.urlValue, {
      headers: { "Accept": "text/html", "X-Requested-With": "XMLHttpRequest" },
      cache: "no-store"
    })
    if (response.ok) {
      this.element.outerHTML = await response.text()
    }
  }
}
